import { useState } from 'react';
import {
  FilterStatusesCheckboxesState,
  FilterStatusesCheckboxStateTypes,
  FilterStatusesProps
} from '../filter-statuses.types';
import cloneDeep from 'lodash/cloneDeep';
import { objectUtility } from '../../../../../utils/object/object';
import { getDefaultCheckboxesState } from '../utils';

const useCheckboxesState = ({ dropListData, handleInput, title, filterForServer }: FilterStatusesProps) => {
  const [checkboxesState, setCheckboxesState] = useState<FilterStatusesCheckboxesState>(
    getDefaultCheckboxesState(dropListData, filterForServer)
  );

  const updateCheckboxState = (type: FilterStatusesCheckboxStateTypes, checked: boolean, id: string) => {
    const newCheckboxState = cloneDeep(checkboxesState);
    switch (type) {
      case FilterStatusesCheckboxStateTypes.Group:
        newCheckboxState[id].checked = checked;
        newCheckboxState[id].indeterminate = false;
        newCheckboxState[id].items.forEach(item => {
          item.checked = checked;
          item.indeterminate = false;
        });
        break;

      case FilterStatusesCheckboxStateTypes.Item:
        objectUtility.entries(newCheckboxState).forEach(([key, value]) => {
          const clickedItem = value.items.find(item => item.id === id);
          if (clickedItem) {
            clickedItem.checked = checked;

            newCheckboxState[key].checked = newCheckboxState[key].items.every(item => item.checked);
            newCheckboxState[key].indeterminate =
              newCheckboxState[key].items.some(item => item.checked) &&
              newCheckboxState[key].items.some(item => !item.checked);
          }
        });
        break;
      default:
        break;
    }
    setCheckboxesState(newCheckboxState);

    const ids: string[] = [];
    objectUtility.values(newCheckboxState).forEach(group => {
      group.items.forEach(item => {
        if (item.checked) {
          ids.push(item.id);
        }
      });
    });
    handleInput(title, ids);
  };

  return { checkboxesState, updateCheckboxState };
};

export default useCheckboxesState;
